import { DatePipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef,
  MatRow, MatRowDef,
  MatTable
} from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { AdminService } from '../../../../admin/admin.service';
import { ReportFieldOptionsService } from '../../../../datatools-settings/report-field-options/report-field-options/report-field-options.service';
import { DatatoolsLiteService } from '../../../../shared/services/datatools-lite.service';
import { DuplikitMergeService } from '../../../../shared/services/duplikit-merge.service';
import { MessageNotificationService } from '../../../../shared/services/message-notification.service';
import { UserInterfaceService } from '../../../../shared/services/user-interface.service';
import { UtilsService } from '../../../../shared/services/utils.service';
import { DuplicateService } from '../../../duplicate.service';
import { DuplikitReportField } from '../../duplikit-report-field';
import { GenericDuplicateDetailsComponent } from '../generic-duplicate-details.component';

@Component({
  selector: 'app-company-duplicate-details',
  templateUrl: '../duplicate-details.component.html',
  imports: [
    NgIf,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatButton,
    NgClass,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatHeaderCellDef,
    MatCell,
    MatCellDef,
    MatTooltip,
    DatePipe,
    MatPaginator,
    MatHeaderRow,
    MatRow,
    MatHeaderRowDef,
    MatRowDef,
    NgForOf
  ],
  styleUrls: ['../duplicate-details.component.scss']
})
export class CompanyDuplicateDetailsComponent extends GenericDuplicateDetailsComponent {
  defaultFieldList: DuplikitReportField[] = [
    { field: 'noOfContacts', label: 'No of Contacts' },
    { field: 'status', label: 'Status' },
    { field: 'dateLastModified', label: 'Date Last Modified', dataType: 'date' },
    { field: 'dateAdded', label: 'Date Added', dataType: 'date' },
    { field: 'address1', label: 'Address 1' },
    { field: 'address2', label: 'Address 2' },
    { field: 'city', label: 'City' },
    { field: 'state', label: 'State' },
    { field: 'zip', label: 'Zip' },
    { field: 'phone', label: 'Phone' },
    { field: 'fax', label: 'Fax' },
    { field: 'companyURL', label: 'Company Url' },
  ];

  constructor(
      messageNotificationService: MessageNotificationService,
      duplicateService: DuplicateService,
      adminService: AdminService,
      dataToolsLiteService: DatatoolsLiteService,
      reportFieldOptionsService: ReportFieldOptionsService,
      utilsService: UtilsService,
      duplikitMergeService: DuplikitMergeService,
      userInterfaceService: UserInterfaceService,
  ) {
    super(
        messageNotificationService,
        duplicateService,
        adminService,
        dataToolsLiteService,
        reportFieldOptionsService,
        utilsService,
        duplikitMergeService,
        userInterfaceService
    );
  }
}
